import {Component, ElementRef, Inject, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { toggleLoading } from "../../../redux";
import {UtilService} from "../../../shared/services";
import {Store} from "@ngrx/store";
import {ToastrService} from "ngx-toastr";
import {SubdocService} from "../../services/subdoc/subdoc.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ISubDocField, ISubDocFieldsResponse, SubDocFieldType } from "../../models/syndication";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";

@Component({
  selector: 'app-deal-subscription-subdoc-form-modal',
  templateUrl: './deal-subscription-subdoc-form-modal.component.html',
  styleUrls: ['./deal-subscription-subdoc-form-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DealSubscriptionSubdocFormModalComponent implements OnInit {

  @ViewChild('docBody', { static: true }) docBody!: ElementRef;
  safeHtml : SafeHtml = "";

  constructor(
    public util: UtilService,
    private store: Store,
    private toastr: ToastrService,
    private subDocService: SubdocService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<DealSubscriptionSubdocFormModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {fields : ISubDocFieldsResponse, isRondeivu?: boolean}) {

      // parse the html and create safeHtml to display
  }

  ngOnInit(): void {
      this.safeHtml = this.parseHtmlContent(this.data.fields);
  }

  private parseHtmlContent(fieldsDto: ISubDocFieldsResponse) : SafeHtml {
    const parser = new DOMParser();
    const doc = parser.parseFromString(fieldsDto.content, 'text/html');

    // replace page breaks
    const pageBreaks = doc.querySelectorAll('x-concord-page-break');
    pageBreaks.forEach(el => {
      const hr = document.createElement('hr');
      el.appendChild(hr);
    });

    // console.log(fieldsDto.fieldsList)

    // Replace <x-concord-field> with <input>
    const fields = doc.querySelectorAll('x-concord-field');
    fields.forEach(xConcordElement => {

      try {
        const fieldUuid = xConcordElement.getAttribute('data-field-uuid');

        if (!!fieldUuid) {
          // get the field from fields
          const concordFields = fieldsDto.fieldsList.filter(x => x.uuid == fieldUuid);

          if (concordFields.length > 0) {
            const concordField = concordFields[0];
            console.log("Concord Field", concordField.type, concordField);

            xConcordElement.classList.add('concord-field');
            xConcordElement.setAttribute("id", fieldUuid);

            if (concordField.type === SubDocFieldType.TEXT) {

              var fieldElement = document.createElement('input');
              fieldElement.setAttribute('type', 'text');
              fieldElement.setAttribute('placeholder', concordField.placeholder);
              fieldElement.id = fieldUuid;
              fieldElement.name = fieldUuid;

              // set value
              if (concordField.values.length > 0)  {
                fieldElement.value = concordField.values[0];
                fieldElement.setAttribute('value', concordField.values[0]);
              }

              xConcordElement.appendChild(fieldElement);

            }
            else if (concordField.type === SubDocFieldType.PARAGRAPH) {
              
              var element = document.createElement('textarea');
              element.setAttribute('placeholder', concordField.placeholder);
              element.id = fieldUuid;
              element.name = fieldUuid;

              // set value
              if (concordField.values.length > 0)  {
                element.textContent = concordField.values[0]
                // element.value = concordField.values[0];
                // element.setAttribute('value', concordField.values[0]);
              }

              xConcordElement.appendChild(element);
            }
            else if (concordField.type === SubDocFieldType.CHECKBOX) {

              xConcordElement.classList.add('concord-checkbox-container');
              concordField.options?.forEach(x => {
                let container = document.createElement('span');
                container.classList.add('concord-checkbox');

                let input = document.createElement('input');
                input.setAttribute('id', x.key);
                input.setAttribute('type', 'checkbox');

                if (concordField.values.includes(x.key))
                  input.setAttribute('checked', 'checked');
                else 
                  input.removeAttribute('checked');


                container.appendChild(input);
                container.appendChild(document.createTextNode(x.value));

                xConcordElement.appendChild(container);
              })
              
            }
            else if (concordField.type === SubDocFieldType.RADIO) {

              xConcordElement.classList.add('concord-radio-container');
              concordField.options?.forEach(x => {
                let container = document.createElement('span');
                container.classList.add('concord-radio');

                let input = document.createElement('input');
                input.setAttribute('id', x.key);
                input.setAttribute('name', concordField.uuid);
                input.setAttribute('type', 'radio');

                if (concordField.values.includes(x.key))
                  input.setAttribute('checked', 'checked');
                else 
                  input.removeAttribute('checked');


                container.appendChild(input);
                container.appendChild(document.createTextNode(x.value));

                xConcordElement.appendChild(container);
              })

            }
            else if (concordField.type === SubDocFieldType.SIGNATURE) {
              let element = document.createElement('span');
              element.title = "This is a signature slot, it will be signed on the Concord platform";
              element.textContent = concordField.values.length > 0 ? concordField.values[0] : concordField.type;
              xConcordElement.appendChild(element);

            }
            else if (concordField.type === SubDocFieldType.SIGNER_COMPANY ||
              concordField.type === SubDocFieldType.SIGNER_FULL_NAME ||
              concordField.type === SubDocFieldType.SIGNER_TITLE
            ) {
              let replaceElement = document.createElement('span');
              replaceElement.title = "This field will be set by the signatory on the Concord platform"
              replaceElement.textContent = concordField.values.length > 0 ? concordField.values[0] : concordField.type;
              xConcordElement.appendChild(replaceElement);
            }
          }
        }
        
      } catch (error) {
        console.error(error)
      }
    });
   
    return this.sanitizer.bypassSecurityTrustHtml(doc.body.innerHTML);
  }

  private getFieldValuesAndSetResponse() : ISubDocField[] {
    const doc = this.docBody.nativeElement;
    const fields = doc.getElementsByTagName('x-concord-field');

    var fieldsForPut = this.data.fields.fieldsList as ISubDocField[];
    if (!!fields && fields.length > 0) {
      // get all fields from html
      for (let i = 0; i < fields.length; i++) {
        try {
          const xConcordElement = fields.item(i);
          if (!!xConcordElement) {
            // single element
            // console.log("ELEMENT", xConcordElement)
            const fieldUuid = xConcordElement.getAttribute('data-field-uuid');

            if (!!fieldUuid) {
              let concordFields = fieldsForPut.filter(x => x.uuid == fieldUuid);

              if (!!concordFields && concordFields.length > 0) {
                //  put the value to the data
                let concordField = concordFields[0];

                if (concordField.type === SubDocFieldType.TEXT) {

                  // get value from textarea
                  var value = xConcordElement.querySelector('input')?.value;
                  concordField.values = !!value ? [value]: [];
                }
                else if (concordField.type === SubDocFieldType.PARAGRAPH) {
                  
                  // get value from textarea
                  var value = xConcordElement.querySelector('textarea')?.value;
                  concordField.values = !!value ? [value]: [];

                } else if (concordField.type === SubDocFieldType.CHECKBOX || 
                            concordField.type === SubDocFieldType.RADIO
                ) {
                  // get 'checked' value from attributes
                  concordField.values = [];
                  (xConcordElement.querySelectorAll('input') as NodeListOf<HTMLInputElement>)?.forEach((input : HTMLInputElement) => {
                    if (input.checked)
                    {
                      concordField.values.push(input.id);
                    }
                  });

                }
              }
            }
          }
        } catch (error) {
          console.error(error);
        }
      }
    }

    return fieldsForPut;
  }



  /**
   * Save the form fields
   * @param approveForSig
   */
  saveFields(approveForSig: boolean) {
    // // format the field so that the info makes sense
    var response : ISubDocFieldsResponse = {
      subDocId: this.data.fields.subDocId,
      content: "",
      approveForInvestorSignatures: approveForSig,
      fieldsList: this.getFieldValuesAndSetResponse()
    };

    console.log("Updating Fields (investor)...", response);

    this.store.dispatch(toggleLoading({loading: true, message: "This operation may take a few seconds!"}));
    this.subDocService.updateDocumentFields(this.data.fields.subDocId, response).subscribe({
      next: (res: any) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.success("Sub Doc Fields Updated!", $localize`:@@companyName:Rondeivu`);
        this.dialogRef.close(approveForSig);
      }, error: err => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Error has occured!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  saveFieldsForRondeivu(approveForRondeivu: boolean) {

    // format the field so that the info makes sense
    var response : ISubDocFieldsResponse = {
      subDocId: this.data.fields.subDocId,
      content: "",
      approveForInvestorSignatures: approveForRondeivu,
      fieldsList: this.getFieldValuesAndSetResponse()
    };

    console.log("Updating Fields (Rondeivu)...", response);

    this.store.dispatch(toggleLoading({loading: true, message: "This operation may take a few seconds!"}));
    this.subDocService.approvalSendToInvestor(this.data.fields.subDocId, response).subscribe({
      next: (res: any) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.success("Sub Doc Fields Updated!", $localize`:@@companyName:Rondeivu`);
        this.dialogRef.close(approveForRondeivu);
      }, error: err => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Error has occured!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

 

  downloadSubdoc() {
    var subDocId = this.data.fields.subDocId;

    this.store.dispatch(toggleLoading({loading: true, message: "This operation may take a few seconds!"}));
    this.subDocService.getSubdocPdf(subDocId).subscribe({
      next: (res: Blob) => {
        let filename = 'subdoc-download.pdf';
        let blob: Blob = res as Blob;
        let a = document.createElement('a');
        a.download = filename;
        a.href = window.URL.createObjectURL(blob);
        a.click();
        this.store.dispatch(toggleLoading({loading: false}));
      },
      error: (err: any) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastr.error("Unable to download file!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }
}

